import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Summary' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 16,
        border: '1px solid #ECECEC'
    },
    content: {
        padding: 24,
        borderRadius: 16,
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        flex: 1
    },
    breadcrumbs: {
        marginBottom: 16
    },
    toggle: {
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0px 0px 16px 16px',
        borderTop: '1px solid #ECECEC',
        background: '#FFFFFF',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        flex: 1,
        transition: 'all 0.3s',
        cursor: 'pointer',
        ['&:hover']: {
            background: '#F8F8F8'
        }
    },
    arrow: {
        width: 16,
        height: 16,
        transition: 'all 0.3s ease-out'
    },
    _expanded: {
        transform: 'rotate(-180deg)'
    },
    description: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 16
    },
    short: {
        margin: 0,
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        color: '#2D2D2D',
        transition: 'all 0.3s',
        opacity: 1
    },
    _pale: {
        opacity: 0.7
    },
    info: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px 12px'
    }
});
